export const CATEGORY_FILTERS_OPTIONS = {
  DEFAULT_PAGE_SIZE: 12,
  DEFAULT_PAGE_OFFSET: 0
};
